import Grid from "@material-ui/core/Grid";
import React from "react";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import { SimpleSearcher } from "../SimpleSearcher/SimpleSearcher";
import { FilterQuerySerialized } from "../../../helpers/serializers/filters";
import { PageQuery } from "../../../api/users/UsersApi";

interface BaseTableSearcherProps {
  loading: boolean;
}

export function BaseTableSearcher({ loading }: BaseTableSearcherProps) {
  const location = useLocation();
  const params = (queryString.parse(location.search) as unknown) as FilterQuerySerialized & PageQuery;

  return (
    <Grid container spacing={2} justify={"flex-start"}>
      <Grid item lg={2} md={2} sm={6} xs={12}>
        <SimpleSearcher name={"id-"} label={"Id"} loading={loading} defaultValue={params["filter[id][]"]} />
      </Grid>
      <Grid item lg={2} md={2} sm={6} xs={12}>
        <SimpleSearcher name={"name"} label={"Имя"} loading={loading} defaultValue={params["filter[name]"]} />
      </Grid>
      <Grid item lg={2} md={2} sm={6} xs={12}>
        <SimpleSearcher name={"email"} label={"E-mail"} loading={loading} defaultValue={params["filter[email]"]} />
      </Grid>
      <Grid item lg={2} md={2} sm={6} xs={12}>
        <SimpleSearcher name={"phone"} label={"Телефон"} loading={loading} defaultValue={params["filter[phone]"]} />
      </Grid>
    </Grid>
  );
}
